import React from 'react';
import { WidgetTemplate } from '../types';
import { ReactComponent as MapIcon } from '../assets/map.svg';
import styles from './WidgetTemplateCard.module.scss';

const CHART_ICONS: Record<string, string> = {
  bar: '\u2587\u2585\u2583\u2581',
  line: '\u2571\u2572\u2571',
  pie: '\u25D4',
  table: '\u2637',
  metric: '#',
  card_grid: '\u229E',
  text: '\u00B6',
  word_cloud: 'Aa',
};

interface WidgetTemplateCardProps {
  template: WidgetTemplate;
  onSelect: (template: WidgetTemplate) => void;
}

export const WidgetTemplateCard: React.FC<WidgetTemplateCardProps> = ({
  template,
  onSelect,
}) => {
  return (
    <button
      className={styles.card}
      onClick={() => onSelect(template)}
    >
      <span className={styles.icon}>
        {template.type === 'map' ? <MapIcon aria-hidden="true" /> : CHART_ICONS[template.type] || '?'}
      </span>
      <span className={styles.label}>{template.label}</span>
      <span className={styles.description}>{template.description}</span>
    </button>
  );
};
